module.exports = __webpack_public_path__ + "img/favicon.b2519d7.png";